const parseVersionSegment = (value, fallback = 0, { min = 0 } = {}) => {
  const parsedValue = Number.parseInt(String(value ?? "").trim(), 10);
  return Number.isFinite(parsedValue) && parsedValue >= min ? parsedValue : fallback;
};

export const parseWorkspaceVersion = (value) => {
  const segments = String(value ?? "")
    .trim()
    .split(".")
    .map((segment) => segment.trim())
    .filter(Boolean);

  const userVersion = parseVersionSegment(segments[0], 1, { min: 1 });
  const publishedVersion = parseVersionSegment(segments[1], 0, { min: 0 });
  const draftVersion = parseVersionSegment(segments[2], 0, { min: 0 });

  return {
    userVersion,
    publishedVersion,
    draftVersion,
    normalized: `${userVersion}.${publishedVersion}.${draftVersion}`,
  };
};

export const normalizeWorkspaceVersion = (value) => parseWorkspaceVersion(value).normalized;

export const getUserControlledWorkspaceVersion = (value) =>
  String(parseWorkspaceVersion(value).userVersion);

export const normalizeUserControlledWorkspaceVersion = (nextValue, existingVersion = null) => {
  const currentVersion = parseWorkspaceVersion(existingVersion);
  const nextUserVersion = parseVersionSegment(
    String(nextValue ?? "").trim().split(".")[0],
    currentVersion.userVersion,
    { min: 1 }
  );

  if (existingVersion && nextUserVersion === currentVersion.userVersion) {
    return currentVersion.normalized;
  }

  return `${nextUserVersion}.0.0`;
};

export const formatVirtualDbVersionLabel = (value, fallbackText = "Virtual DB Unknown") => {
  const normalizedVersion = String(value ?? "").trim();
  return normalizedVersion ? `Virtual DB ${normalizeWorkspaceVersion(normalizedVersion)}` : fallbackText;
};
